import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { appConfirm } from "@/components/AppDialogHost";

const empty = { name: "", bio: "", profile_image: "", email: "", role: "writer", social_links: {} };

export default function MagAuthors() {
  const [authors, setAuthors] = useState([]);
  const [form, setForm] = useState(null);
  const load = () => api.get("/mag/authors").then((r) => setAuthors(r.data.authors || []));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (form.author_id) await api.put(`/mag/authors/${form.author_id}`, form);
      else await api.post("/mag/authors", form);
      toast.success("Author saved"); setForm(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };

  return (
    <div className="space-y-4 max-w-3xl" data-testid="mag-authors">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold">Authors</h1>
        <button onClick={() => setForm({ ...empty })} data-testid="mag-add-author-btn" className="rounded-full bg-brand-amber text-black px-4 py-2 text-sm font-bold">Add Author</button>
      </div>
      <div className="rounded-xl border border-line bg-bg-surface divide-y divide-line">
        {authors.map((a) => (
          <div key={a.author_id} className="flex items-center gap-3 px-4 py-3" data-testid={`mag-author-row-${a.author_id}`}>
            {a.profile_image ? <img src={a.profile_image} alt="" className="h-9 w-9 rounded-full object-cover" /> : <div className="h-9 w-9 rounded-full bg-bg-elevated" />}
            <div className="flex-1">
              <div className="text-sm font-semibold">{a.name}</div>
              <div className="text-[11px] font-mono text-ink-muted">{a.email}</div>
            </div>
            <span className="rounded-full border border-line px-2 py-0.5 text-[10px] font-bold uppercase text-ink-secondary">{a.role}</span>
            <button onClick={() => setForm(a)} className="px-2 py-1 text-xs rounded border border-line">Edit</button>
            <button onClick={async () => { if (await appConfirm("Remove author?")) { await api.delete(`/mag/authors/${a.author_id}`); load(); } }}
              className="px-2 py-1 text-xs rounded border border-line text-red-300/80">Remove</button>
          </div>
        ))}
      </div>
      {form && (
        <div className="rounded-xl border border-brand-amber/40 bg-bg-surface p-4 space-y-2" data-testid="mag-author-form">
          {["name", "email", "profile_image", "bio"].map((k) => (
            <input key={k} value={form[k] || ""} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))}
              placeholder={k.replace("_", " ")} data-testid={`mag-author-${k}`}
              className="w-full rounded-md border border-line bg-bg-elevated px-3 py-2 text-sm" />
          ))}
          <select value={form.role} onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))} data-testid="mag-author-role"
            className="w-full rounded-md border border-line bg-bg-elevated px-3 py-2 text-sm">
            <option value="admin">Owner / Admin — full access</option>
            <option value="editor">Editor — create, edit, schedule, publish</option>
            <option value="writer">Writer — drafts only</option>
          </select>
          <div className="flex gap-2">
            <button onClick={save} data-testid="mag-author-save" className="rounded-full bg-brand-amber text-black px-4 py-1.5 text-xs font-bold">Save</button>
            <button onClick={() => setForm(null)} className="rounded-full border border-line px-4 py-1.5 text-xs">Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
